import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';

interface VentasOption {
  title: string;
  description: string;
  icon: string;
  route: string;
  requiredRoles: string[];
  color: string; // Tailwind color class
  rbacPermissions?: string[];
  hidden?: boolean;
}

@Component({
  selector: 'app-ventas-dashboard',
  templateUrl: './ventas-dashboard.component.html',
  styleUrls: []
})
export class VentasDashboardComponent implements OnInit {
  options: VentasOption[] = [
    {
      title: 'Compras Financiadas',
      description: 'Consulta todas las compras financiadas por tienda y por producto',
      icon: 'fas fa-shopping-cart',
      route: '/console/invoice-dashboard',
      requiredRoles: ['OWNER', 'ANALIST'],
      color: 'bg-blue-100 text-blue-600',
      rbacPermissions: ['ventas.facturas.read']
    },
    {
      title: 'Calculadora de Crédito',
      description: 'Simula y calcula diferentes escenarios de crédito según los diferentes planes de financiamiento',
      icon: 'fas fa-calculator',
      route: '/console/credit-calculator',
      requiredRoles: ['HIDDEN'],
      color: 'bg-blue-100 text-blue-600',
      rbacPermissions: ['ventas.facturas.create'],
      hidden: true // Desactivado — no forma parte del módulo Ventas según documento MT
    }
  ];

  userRoles: string[] = [];

  constructor(public _auth: AuthService) {}

  ngOnInit(): void {
    this.userRoles = Array.isArray(this._auth.sessionUser?.profile) ? this._auth.sessionUser.profile : [];
  }

  hasPermission(option: VentasOption): boolean {
    if (option.hidden) return false;
    if (this._auth.hasRbac$.getValue()) {
      if (option.rbacPermissions && option.rbacPermissions.length > 0) {
        return this._auth.hasAnyPermission(option.rbacPermissions);
      }
      return this._auth.hasModuleAccess('ventas');
    }
    if (!option.requiredRoles || option.requiredRoles.length === 0) return true;
    return option.requiredRoles.some(role => this.userRoles.includes(role));
  }
}
